import { React } from 'react';

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import "./index.scss";

const RightFooter = () => {

    const { t } = useTranslation();

    return (
        <div className="right-footer mt-5">
            <ul type="none">
                <li>
                    <Link
                        to="https://www.cybermindr.com/contact-us/"
                        target="_blank"
                        className="custom-link"
                    >
                        {t('loginPage.rightSection.contact')}
                    </Link>
                </li>
                <li>
                    <Link
                        // to="https://www.cybermindr.com/privacy-policy/"
                        // target="_blank"
                        className="custom-link"
                    >
                        {t('loginPage.rightSection.PrivacyPolicy')}
                    </Link>
                </li>
                <li>
                    <Link
                        to="https://www.cybermindr.com/about-us/"
                        target="_blank"
                        className="custom-link"
                    >
                        {t('loginPage.rightSection.aboutCybermindr')}
                    </Link>
                </li>
            </ul>
        </div>
    )
}

export default RightFooter;